import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { Heading, SimpleLink, SuperButton } from "../../elements";
import "./style.scss";

const CheckoutErrorView = ({ error, showError, onClose }) => {
  const [show, setShow] = useState(showError);
  useEffect(() => {
    setShow(showError);
  }, [showError]);
  if (!error) {
    return null;
  }
  const { headingType, headingBody, body, link, ctaType, ctaName, iconName, colorScheme } = error || {};
  console.log("colorScheme", colorScheme);
  const modalProps = {
    showModal: show,
    onCloseClicked: () => {
      onClose && onClose();
    }
  };
  const ctaProps = ctaName?.value
    ? {
        buttonText: ctaName.value,
        ctaType: ctaType,
        iconName: iconName,
        colorScheme: colorScheme,
        callback: () => {
          onClose && onClose();
        }
      }
    : null;
  return (
    <Modal {...modalProps}>
      <section className="pre-sales-checkout checkout-error-view grid modal">
        {headingType && headingBody && (
          <div className="title">
            <Heading type={headingType} html={headingBody} />
          </div>
        )}
        {body && (
          <div className="info">
            <p
              dangerouslySetInnerHTML={{
                __html: body.value
              }}
            />
          </div>
        )}
        <div className={`cta ${!ctaProps ? "try-again" : "support"}`}>
          {ctaProps && <SuperButton {...ctaProps} />}
          {!ctaProps && link && <SimpleLink {...link.value} />}
        </div>
      </section>
    </Modal>
  );
};
export default CheckoutErrorView;
